import operationTypes from 'constants/operationTypes';

export type SharesTransferLabels = {
  title: string;
  transmittingDate: string;
  transmittingPartner: string;
  transmittingSharesNumber: string;
  recipientPartner: string;
  addTransmit: string;
};

const headersLabelSell = {
  title: 'SaleOfShares',
  transmittingDate: 'TransmissionDate',
  transmittingPartner: 'PartnerThatSells',
  transmittingSharesNumber: 'NºParticipationsThatSells',
  recipientPartner: 'PartnerThatBuys',
  addTransmit: 'AddAnotherSale',
};
const headersLabelHeritage = {
  title: 'Heritage',
  transmittingDate: 'TransmissionDate',
  transmittingPartner: 'TransmittingPartner',
  transmittingSharesNumber: 'TransmittingSharesNumber',
  recipientPartner: 'RecipientHeritagePartner',
  addTransmit: 'AddHeritage',
};
const headersLabelDonation = {
  title: 'Donation',
  transmittingDate: 'DonationDate',
  transmittingPartner: 'DonationPartner',
  transmittingSharesNumber: 'DonationSharesNumber',
  recipientPartner: 'RecipientDonationPartner',
  addTransmit: 'AddDonation',
};

const headersLabelEndorsement = {
  title: 'Endorsement',
  transmittingDate: 'EndorsementDate',
  transmittingPartner: 'EndorsementPartner',
  transmittingSharesNumber: 'EndorsementSharesNumber',
  recipientPartner: 'RecipientEndorsementPartner',
  addTransmit: 'AddEndorsement',
};

const headersLabelTransmission = {
  title: 'Transmission',
  transmittingDate: 'TransmissionDate',
  transmittingPartner: 'TransmissionPartner',
  transmittingSharesNumber: 'TransmissionSharesNumber',
  recipientPartner: 'RecipientTransmissionPartner',
  addTransmit: 'AddTransmission',
};

export const getSharesTransferLabels = (operationType: string) => {
  switch (operationType) {
    case operationTypes.SELL_PARTICIPATION:
      return headersLabelSell;
    case operationTypes.HERITAGE:
      return headersLabelHeritage;
    case operationTypes.DONATION:
      return headersLabelDonation;
    case operationTypes.ENDORSEMENT:
      return headersLabelEndorsement;
    case operationTypes.TRANSMISSION:
      return headersLabelTransmission;
    default:
      return headersLabelSell;
  }
};
